import Button from '@/common/components/Button'
import { dateTransformer } from '@/common/utils/dateTransformer'
import { truncateText } from '@/common/utils/formatters'
import { priceSurveyStatusStrategy } from '@/features/priceSurvey/constants/priceSurveyStatusOptions.constant'
import { PriceSurveyData, PriceSurveysTableItem } from '@/features/priceSurvey/types/priceSurvey.type'
import { ArrowBigRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'

export class PriceSurveyTransformer {
  static tableTransformer({
    operationKlassToCheckPermission,
  }: {
    operationKlassToCheckPermission?: string
  }): (events: PriceSurveyData[]) => PriceSurveysTableItem[] {
    return (priceSurveys: PriceSurveyData[]) => {
      return priceSurveys.map((priceSurvey) => {
        const tooltipId = `${priceSurvey.id}-cities-tooltip`
        const cities = priceSurvey.cities.map((city) => city.display_name).join(', ')

        return {
          ...priceSurvey,
          status: priceSurveyStatusStrategy[priceSurvey.status as keyof typeof priceSurveyStatusStrategy],
          city: (
            <>
              <p data-tooltip-id={tooltipId} className="max-w-lg">
                {truncateText(cities, 64)}
              </p>
              {cities.length > 64 && (
                <Tooltip id={tooltipId} className="z-50 max-w-96 text-wrap">
                  {cities}
                </Tooltip>
              )}
            </>
          ),
          survey_conducted_at: dateTransformer(priceSurvey.survey_conducted_at),
          actions: (
            <Link to={`/price-survey/${priceSurvey.id}`}>
              <Button
                name="access_company_user"
                className="bg-transparent hover:bg-transparent p-0"
                operationKlassToCheckPermission={operationKlassToCheckPermission}
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
